import { Typography } from '@mui/material';

const ContactsPage = () => <Typography variant="h2">Contacts Page</Typography>;

export default ContactsPage;
